import Helper from '@ember/component/helper';
import characterFromNumberUtil from 'cio/utils/character-from-number';

export function characterFromNumber([value]) {
  return characterFromNumberUtil(value);
}

export default Helper.helper(characterFromNumber);
